module.exports = "/_next/static/images/056aaf02daf4e894546befd34780f1d1-icon-1.svg.webp";